import { Route, Routes } from 'react-router-dom'
import OrdersPage from '../../pages/shared-pages/orders/OrdersPage'
import OrderDetailsPage from '../../pages/shared-pages/orders/OrderDetailsPage'

export default function OrderNav() {
  return (
    <Routes>

      <Route path="/" element={<OrdersPage />} />
      <Route path="/details" element={<OrderDetailsPage />} />

    </Routes>
  )
}
